import { action } from 'satcheljs';

/**
 * Action to notify that the calendar events changed via server sent events.
 */
const showHideFeedbackForm = action('showHideFeedbackForm', (show: boolean) => ({
    show,
}));

export default showHideFeedbackForm;
